export const fullScaleAutonomousDrivingEN = {
  title: "R&D for Various Intelligent Agents",
  subtitle:
    "Research and development of complex intelligent agents based on high-validity simulation, providing customized intelligent Automation solutions for diverse scenarios.",
  solution: {
    title: "Support Multi-scenario Intelligent Agent Solutions",
    subtitle:
      "Enabling higher efficiency and enhanced safety for automated systems in unstructured scenarios.",
    list: [
      {
        title: "Mining Trucks",
        subtitle:
          "Automated driving for complex road conditions in mining areas",
      },
      {
        title: "Unmanned Container Trucks",
        subtitle: "Automation of container transportation at ports",
      },
      {
        title: "Automated Agricultural Machinery",
        subtitle: "Automated driving technology for agricultural machinery",
      },
      {
        title: "Embodied Intelligence",
        subtitle: "High intelligence bionic mobile robot",
      },
      {
        title: "Low-altitude Economy",
        subtitle: "Large-scale UAV swarm intelligence",
      },
    ],
    tip: "The illustrations depict general industry examples only. They neither represent our products nor are affiliated with any third-party brands.",
  },
};
export const fullScaleAutonomousDrivingCN = {
  title: "全境智能研发",
  subtitle:
    "基于高逼真度仿真的复杂智能体研发，为多元场景提供定制化智能解决方案",
  solution: {
    title: "支持全场景自动驾驶解决方案",
    subtitle: "实现更高效、更安全的非结构场景自动化",
    list: [
      {
        title: "矿车自动驾驶",
        subtitle: "针对矿区复杂路况的自动驾驶",
      },
      {
        title: "港口无人集卡",
        subtitle: "港口集装箱运输的自动化",
      },
      {
        title: "农机自动驾驶",
        subtitle: "农业机械自动驾驶",
      },
      {
        title: "具身智能",
        subtitle: "高智能仿生移动机器人",
      },
      {
        title: "低空经济",
        subtitle: "大规模无人机群体智能",
      },
    ],
    tip: "图示仅为行业通用示例，非本公司产品，与任何品牌方无关联",
  },
};
